export const selectRobotsData = (state) => state.robots?.data || [];
export const selectRobotsLoading = (state) => state.robots?.loading || false;
export const selectRobotsError = (state) => state.robots?.error || null;
export const selectSelectedRobot = (state) => state.robots?.selectedRobot || null;
export const selectRobotMaintenanceRecordsData = (state) => state.robots?.maintenanceRecords || [];
export const selectMaintenanceRecordData = (state) => state.robots?.selectedMaintenanceRecord || null;
export const selectRobotMaintenanceData = (state) => state.robots?.maintenanceData || null;
export const selectCellHistoryData = (state) => state.robots?.cellHistoryData || [];

